// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24UJp","rightAdornment":"Header_rightAdornment__2UrIY"};